import { config, httpHelper } from 'modules/common/helpers';

const BASE_URL = config.beUrl;

export default {
  addQuestionnaireReminder,
};

function addQuestionnaireReminder({ date, id }) {
  return httpHelper.post(`${BASE_URL}/api/remind/answer`, { date, id });
}
